var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnvelopeFilled = function SvgEnvelopeFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.154,
    height: 16.28
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.036 16.28a2 2 0 0 1-.872-.2l7.023-6.977.993.994a3.4 3.4 0 0 0 4.795 0l.994-.994 7.023 6.977a2 2 0 0 1-.872.2Zm13.892-8.139 7.023-6.977a2 2 0 0 1 .2.872v12.211a2 2 0 0 1-.2.872ZM0 14.246V2.035a2 2 0 0 1 .206-.872L7.227 8.14.206 15.117a2 2 0 0 1-.204-.87Zm10.14-5.112L1.164.202a2.04 2.04 0 0 1 .872-.2h19.085a2.05 2.05 0 0 1 .872.2l-8.976 8.932a2.03 2.03 0 0 1-1.439.595 2.03 2.03 0 0 1-1.438-.594Z",
    "data-name": "message"
  })));
};
export default SvgEnvelopeFilled;